import { VuiHelmet } from "../../../../@vendor/components";
import { useTranslation } from "react-i18next";
import BookingCounselingModule from "../../../../modules/booking-counseling/components/booking-counseling";

const BookingCounseling = () => {
  const { t } = useTranslation();

  return (
    <div id="app-book-counseling-page">
      <VuiHelmet title={t("common.text.bookCounseling")} />

      <BookingCounselingModule />
    </div>
  );
};

export default BookingCounseling;
